import React, { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import "./RangeCalendar.css";
import { useTranslation } from "../../contexts/TranslationContext";
import { addLocale, locale } from "primereact/api";
import Cookies from "js-cookie";

addLocale("ar", {
  firstDayOfWeek: 0, // Sunday
  dayNames: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
  dayNamesShort: ["أحد", "اثن", "ثلا", "أرب", "خمي", "جمع", "سبت"],
  dayNamesMin: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  monthNames: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
  monthNamesShort: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
  //   monthNamesShort: [
  //     'ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون',
  //     'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'
  //   ],
  today: "اليوم",
  clear: "مسح",
  now: "الاَن",
  dateFormat: "dd/mm/yy",
  weekHeader: "أسبوع",
});

const RangeCalendar = ({ value, onChange, minDate, maxDate }) => {
  const [internalValue, setInternalValue] = useState(null);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  // Convert string dates to Date objects
  const minDateObj = minDate ? new Date(minDate) : null;
  const maxDateObj = maxDate ? new Date(maxDate) : null;
  const Lang = Cookies.get("preferred_language") || "en";

  // Set locale dynamically before rendering Calendar
  locale(Lang === "ar" ? "ar" : "en");

  const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (e) => {
    const selectedDates = e.value;
    setInternalValue(selectedDates);
    setError(null); // Reset error on new selection

    // Validate date range
    if (selectedDates?.[0] && selectedDates?.[1]) {
      const start = selectedDates[0];
      const end = selectedDates[1];

      if (minDateObj && start < minDateObj) {
        setError(
          `Earliest available date is ${minDateObj.toLocaleDateString()}`
        );
        return;
      }

      if (maxDateObj && end > maxDateObj) {
        setError(`Latest available date is ${maxDateObj.toLocaleDateString()}`);
        return;
      }

      // onChange({
      //   startDate: start.toISOString().split('T')[0],
      //   endDate: end.toISOString().split('T')[0]
      // });

      onChange({
        startDate: formatDateLocal(start),
        endDate: formatDateLocal(end),
      });
    } else if (!selectedDates?.[0] && !selectedDates?.[1]) {
      onChange({ startDate: null, endDate: null });
    }
  };

  useEffect(() => {
    if (value?.startDate && value?.endDate) {
      const start = new Date(value.startDate);
      const end = new Date(value.endDate);
      setInternalValue([start, end]);
    } else {
      setInternalValue(null);
    }
  }, [value]);

  return (
    <div className="range-calendar-container">
      <Calendar
        locale={Lang === "ar" ? "ar" : "en"}
        dir={Lang === "ar" ? "rtl" : "ltr"}
        value={internalValue}
        onChange={handleDateChange}
        selectionMode="range"
        numberOfMonths={2}
        hideOnRangeSelection={true}
        readOnlyInput
        placeholder={t("SelectDateRange")}
        dateFormat="mm/dd/yy"
        className="range-calendar-input"
        showButtonBar
        onClearButtonClick={(e) => handleDateChange(e)}
        minDate={minDateObj}
        maxDate={maxDateObj}
      />
      {error && <div className="calendar-error">{error}</div>}
    </div>
  );
};

export default RangeCalendar;
